import React, { InputHTMLAttributes } from "react";

import { Box, CompassColor } from "@noom/wax-component-library";

import { Checkbox } from "./Checkbox";

type CheckboxButtonProps = InputHTMLAttributes<HTMLInputElement> & {
  invertLabelColorsOnChecked?: boolean;
};

export const CheckboxButton: React.FC<CheckboxButtonProps> = ({
  checked,
  children,
  invertLabelColorsOnChecked = true,
  ...rest
}) => {
  const shouldInvertLabelColors = invertLabelColorsOnChecked && checked;

  return (
    <Box
      as="label"
      alignItems="center"
      backgroundColor={shouldInvertLabelColors ? CompassColor.lagoon : CompassColor.offWhite}
      border="none"
      borderRadius="8px"
      boxSizing="border-box"
      color={shouldInvertLabelColors ? CompassColor.white : CompassColor.black}
      display="flex"
      justifyContent="flex-start"
      minHeight="60px"
      padding="0 var(--spacing-m)"
      position="relative"
      width="100%"
      _hover={{
        backgroundColor: shouldInvertLabelColors ? CompassColor.lagoon : CompassColor.sand02,
      }}
    >
      <input
        type="checkbox"
        checked={checked}
        style={{
          appearance: "none",
          border: "0",
          cursor: "pointer",
          height: "100%",
          left: 0,
          position: "absolute",
          top: 0,
          width: "100%",
        }}
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...rest}
      />
      <Checkbox checked={checked} />
      {children as React.ReactNode}
    </Box>
  );
};
